module.exports = __webpack_public_path__ + "static/widget-img-14-01c19ea67ce272f9d860ce8e6f2b21eb.png";